module.exports = __webpack_public_path__ + "img/Group 1671@2x.bd36c260.png";